// Web Push helper — register the service worker, subscribe/unsubscribe, and
// sync the subscription to the server. Public VAPID key is safe to embed.
const VAPID_PUBLIC = 'BHvhFEUzcHj-ORGH1n94VrWjYgx5gTRJNudFGZuFuPF1DZBWL7KxUnd93NtC0Wqa4KzZf9dqPpJgudMx2mcl9_g';

function urlB64ToUint8(base64) {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(b64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported() {
  return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function registerSW() {
  if (!('serviceWorker' in navigator)) return null;
  try { return await navigator.serviceWorker.register('/sw.js'); } catch (_e) { return null; }
}

export async function currentPermission() {
  return (typeof Notification !== 'undefined') ? Notification.permission : 'denied';
}

export async function isSubscribed() {
  try { const reg = await navigator.serviceWorker.ready; const sub = await reg.pushManager.getSubscription(); return !!sub; } catch (_e) { return false; }
}

export async function enablePush(email) {
  if (!pushSupported()) throw new Error('Push not supported on this browser');
  const reg = (await navigator.serviceWorker.getRegistration()) || (await registerSW());
  if (!reg) throw new Error('Service worker failed to register');
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Notifications permission denied');
  await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64ToUint8(VAPID_PUBLIC) });
  const r = await fetch('/api/push-subscribe', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, subscription: sub.toJSON(), user_agent: navigator.userAgent }) });
  if (!r.ok) throw new Error('Could not save subscription');
  return true;
}

export async function disablePush() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) { await fetch('/api/push-subscribe', { method: 'DELETE', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ endpoint: sub.endpoint }) }); await sub.unsubscribe(); }
    return true;
  } catch (_e) { return false; }
}

// Fire a test push to myself
export async function sendTestPush(email) {
  await fetch('/api/notify', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email, event: 'general', title: 'Sanoire test', body: 'Notifications are working 🎉', url: '/?screen=dispatch' }) });
}
